export default function Divider() {
  return <div className="h-[1px] w-full bg-purple70 dark:bg-dark my-6" />;
}
